import { apiGet, apiPost } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";

export function getCustomersList(url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.customer.customerList()+url)
            dispatch({
                type: 'SCAN_INFO_CUSTOMER_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function getOrganizationList (url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.organizations.organizationList()+url);
            dispatch({
                type: 'SCAN_INFO_ORGANIZATION_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    };
}

export function getDomainList(url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.domains.domainList()+url)
            dispatch({
                type: 'SCAN_INFO_DOMAIN_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetDomainListResponse() {
    return (dispatch) => {
        dispatch({
            type: 'SCAN_INFO_RESET_DOMAIN_LIST'
        })
    }
}

export function getScanHistory(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scan.scanHistory()+url)
            dispatch({
                type: 'SCAN_INFO_SCAN_HISTORY_SUCCESS',
                payload: response.data
            })
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetScanHistoryList() {
    return (dispatch) => {
        dispatch({
            type: "SCAN_INFO_RESET_SCAN_HISTORY_LIST"
        })
    }
}

export function getWhoisInformation(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.domainInfo.whois()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'WHOIS_INFORMATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'WHOIS_INFORMATION_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getSubdomainList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.subDomain.subDomainList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SUBDOMAIN_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SUBDOMAIN_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetSubdomainList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SUBDOMAIN_LIST"
        })
    }
}

export function getARecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_ARECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_ARECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getAAARecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_AAARECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_AAARECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getCNAMERecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_CNAMERECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_CNAMERECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getMXRecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_MXRECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_MXRECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getNSRecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_NSRECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_NSRECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getSOARecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_SOARECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_SOARECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getTXTRecord(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_TXTRECORD_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_TXTRECORD_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetDnsRecordList() {
    return async (dispatch) => {
        dispatch(({
            type: 'RESET_DNS_RECORD_LIST'
        }))
    }
}

export function getSubDomainTechnologies(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.subDomain.Technologies()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SUBDOMAIN_TECHNOLOGIES_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SUBDOMAIN_TECHNOLOGIES_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getSSLCertificate(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SSL_CERTIFICATE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SSL_CERTIFICATE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getIPAddressList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.ipAddress.ipAddressList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'IP_ADDRESS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'IP_ADDRESS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetIpAddressList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_IP_ADDRESS_LIST"
        })
    }
}

export function getIpAddressSubdomain(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.ipAddress.subDomain()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'IP_ADDRESS_SUBDOMAIN_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'IP_ADDRESS_SUBDOMAIN_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getIpAddressPortInfo(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.ipAddress.portList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'IP_ADDRESS_PORT_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'IP_ADDRESS_PORT_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getTechnologyList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.technology.technologyList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'TECHNOLOGY_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'TECHNOLOGY_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetTechnologiesList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_TECHNOLOGY_LIST"
        })
    }
}

export function getEndPointList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'ENDPOINTS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ENDPOINTS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getSSLCerificateList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.sslCertificate.sslCertificateList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SSL_CERTIFICATE_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SSL_CERTIFICATE_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetSSLCertificateList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_SSL_CERTIFICATE_LIST'
        })
    }
}

export function getMobileAppsList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.MobileApps.mobileAppsList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'MOBILE_APPS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'MOBILE_APPS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetMobileAppsList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_MOBILE_APPS_LIST"
        })
    }
}

export function validateList(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.MobileApps.validate(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'VALIDATE_SUCCESS',
                    payload: response.data.detail
                })
            } else {
                dispatch({
                    type: 'VALIDATE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetValidateResponse() {
    return (dispatch) => {
        dispatch({
            type: "RESET_VALIDATE_SUCCESS"
        })
    }
}

export function deleteMobileAppList(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.MobileApps.deleteMobileApp(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'DELETE_MOBILE_APP_SUCCESS',
                    payload: response.data.detail
                })
            } else {
                dispatch({
                    type: 'DELETE_MOBILE_APP_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    } 
}

export function resetDeleteMobileAppResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_DELETE_MOBILE_APP'
        })
    }
}

export function geCERStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.corporateEmailRisk.cerStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'CER_STATS_SUCCESS',
                    payload: response.data.stats
                })
            } else {
                dispatch({
                    type: 'CER_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetCERStatus() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_CER_STATUS'
        })
    }
}

export function getCERData(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'CER_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'CER_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetCERDataList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_CER_DATA_LIST"
        })
    }
}

export function getGitLeaks(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.gitLeaks.gitLeaksList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GIT_LEAKS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GIT_LEAKS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetGitLeaksList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_GIT_LEAKS_LIST'
        })
    }
}

export function getJsSecretsList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.jsSecrets.jsSecretsList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'JS_SECRETS_LEAKS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'JS_SECRETS_LEAKS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetJsSecretsList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_JS_SECRETS_LIST'
        })
    }
}

export function getSensitiveExpoList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.sensitiveExpo.sensitiveExpoList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SENSITIVE_EXPO_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SENSITIVE_EXPO_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetSensitiveExpoList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_SENSITIVE_EXPO_LIST'
        })
    }
}

export function getSensitiveEndpoints(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.sensitiveExpo.sensitiveEndpoints()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SENSITIVE_ENDPOINTS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SENSITIVE_ENDPOINTS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getJsSecretsEndpoints(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.jsSecrets.jsSecretsEndpoint()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'JS_SECRETS_ENDPOINTS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'JS_SECRETS_ENDPOINTS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getLeakedCredentials(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.leakedCredentialsList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'LEAKED_CREDENTALS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'LEAKED_CREDENTALS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getLeakedCredentialsDataList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.leakedCredentialsData()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'LEAKED_CREDENTALS_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'LEAKED_CREDENTALS_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getBotnetLeaksList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.botnetLeaksList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'BOTNET_LEAKS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BOTNET_LEAKS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getBotnetLeaksDataList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.botnetLeakData()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'BOTNET_LEAKS_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BOTNET_LEAKS_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getRansomewareGroup(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.ransomwareGroupList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'RANSOMEWARE_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RANSOMEWARE_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getRansomweregroupData(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.darkWeb.ransomwareGroupLeaks()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'RANSOMEWARE_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RANSOMEWARE_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getExternalDetectedList(url, type) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'EXTERNAL_DETECTED_LIST_SUCCESS',
                    payload: response.data,
                    listType: type
                })
            } else {
                dispatch({
                    type: 'EXTERNAL_DETECTED_LIST_SUCCESS',
                    payload: response.detail,
                    listType: type
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetExternalDetectedList(type) {
    return (dispatch) => {
        dispatch({
            type: 'RESET_EXTERNAL_DETECTED_LIST',
            listType: type
        })
    }    
}

export function getAffectedEndpointList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'AFFECTED_ENDPOINTS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'AFFECTED_ENDPOINTS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getSimilarDomainList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.brandInsight.similarDomain.similarDomain()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SIMILAR_DOMIAN_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SIMILAR_DOMIAN_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getSimilarDomainSSL(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.brandInsight.similarDomain.sslCertificate()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SIMILAR_DOMAIN_SSL_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SIMILAR_DOMAIN_SSL_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getAssociatedDomainList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.associatedDomain.associatedDomainList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'ASSOCIATED_DOMAIN_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ASSOCIATED_DOMAIN_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetAssociatedDomainList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ASSOCIATED_DOMAIN_LIST"
        })
    }
}

export function getAssociatedDomainSSL(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.associatedDomain.associatedDomainSSL()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'ASSOCIATED_DOMAIN_SSL_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ASSOCIATED_DOMAIN_SSL_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getScanInfoStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url)
            if(response?.status === 200) {
                dispatch({
                    type: 'SCAN_INFO_STATS_SUCCESS',
                    payload: response.data.stats
                })
            } else {
                dispatch({
                    type: 'SCAN_INFO_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetScanInfoStats() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_SCAN_INFO_SUCCESS'
        })
    }
}

export function updateListData(url, obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(url, obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'UPDATE_DATA_LIST_SUCCESS',
                    payload: response.data.detail
                })
            } else {
                dispatch({
                    type: 'UPDATE_DATA_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetUpdateListDataResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_UPDATE_DATA_LIST'
        })
    }
}

export function getPortfolioRiskList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.portfolioRisk.portfolioRiskList()+url)
            if(response?.status === 200) {
                dispatch({
                    type: 'PORTFOLIO_RISK_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'PORTFOLIO_RISK_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function getPortfolioDomain(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.portfolioRisk.portfolioDomainList()+url)
            if(response?.status === 200) {
                dispatch({
                    type: 'PORTFOLIO_RISK_DOMAIN_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'PORTFOLIO_RISK_DOMAIN_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function getPorfolioCustomersList(url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.customer.customerList()+url)
            dispatch({
                type: 'PORTFOLIO_CUSTOMER_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function portfolioCustomerSelectedValue(data) {
    return (dispatch) => {
        dispatch({
            type: 'PORTFOLIO_CUSTOMER_SELECTED_VALUE',
            payload: data
        })
    }
}

export function resetPortfolioDomainList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_PORTFOLIO_DOMAIN_LIST',
        })
    }
}

export function getPortfolioStatus(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.portfolioRisk.portfolioStatus()+url)
            dispatch({
                type: 'PORTFOLIO_RISK_STATUS_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function getBacklinkList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.brandInsight.backlinkAudit.backlinkAuditList()+url)
            if(response?.status === 200) {
                dispatch({
                    type: 'BACKLINK_AUDIT_LIST',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BACKLINK_AUDIT_LIST',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetBacklinkList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_BACK_LINK_LIST',
        })
    }
}